module.exports = __webpack_public_path__ + "static/media/stofferingen-30.151a95b8.jpg";